export const types = ['run', 'trail', 'walk', 'hike', 'cycle', 'swim', 'yoga']
